import React from 'react';
import {
  FaRegUser,
  FaInfo,
  FaKey,
  FaRightFromBracket,
  FaBars,
  FaCalendarCheck,
  FaBagShopping,
} from 'react-icons/fa6';
import ChangeOwnPasswordView from '../../../dialogs/change-own-password/ChangeOwnPassword.view.tsx';
import styles from './Menu.mobile.module.css';
import HistoryDialogView from '../../../dialogs/history-dialog/HistoryDialog.view';
import { useMenuController } from '../Menu.controller';
import { useTranslation } from 'react-i18next';
import canViewMarketComponentHistory from '../../../security/CanViewMarketComponentHistory';
import BurgerMenuView from '../../burger-menu/BurgerMenu.view';
import MarketComponentDetailsDialogView from '../../../dialogs/market-component-details-dialog/MarketComponentDetailsDialog.view';
import MarketSelectionView from '../../market-selection/MarketSelection.view.tsx';
import { formatVersion } from '../../../tools/formatters/VersionFormatter.ts';
import LoaderView from '../../loader/Loader.view.tsx';

export default function MenuMobileView() {
  const { t } = useTranslation();
  const {
    firstname,
    lastname,
    handleHistoryClick,
    handleLogoutClick,
    handleChangeOwnPasswordClick,
    handleChangeOwnPasswordDialogCloseClick,
    isChangeOwnPasswordDialogOpen,
    handleMarketSelectionChanged,
    handleHistoryDialogCloseClick,
    handleDetailsDialogCloseClick,
    handleRedRackClick,
    setIsBurgerMenuOpen,
    selectedValue,
    isHistoryDialogOpen,
    isDetailsDialogOpen,
    isMarketSelectionOpen,
    loading,
    marketComponentForValidation,
    backendVersion,
    isBurgerMenuOpen,
  } = useMenuController();

  const items = [];

  // logo
  items.push({
    child: (
      <div className={styles.headingContainer}>
        <div className={styles.menuVersionContainer}>
          <p>{formatVersion(backendVersion?.version, t)}</p>
        </div>
        <div className={styles.logoContainer}>
          <img className={styles.logo} src="/images/logo.png" alt={t('ui.altLogo')} />
        </div>
      </div>
    ),
  });

  // change own password
  items.push({
    child: (
      <div
        className={styles.itemContainer}
        onClick={() => {
          handleChangeOwnPasswordClick();
        }}
      >
        <div className={styles.iconContainer}>
          <FaKey className={styles.icon} />
        </div>
        <div>
          <p className={styles.itemLabel}>{t('ui.changeOwnPassword')}</p>
        </div>
      </div>
    ),
  });

  // logout
  items.push({
    child: (
      <div
        className={styles.itemContainer}
        onClick={() => {
          setIsBurgerMenuOpen(false);
          handleLogoutClick();
        }}
      >
        <div className={styles.iconContainer}>
          <FaRightFromBracket className={styles.icon} />
        </div>
        <div>
          <p className={styles.itemLabel}>{t('ui.logout')}</p>
        </div>
      </div>
    ),
  });

  // history
  if (canViewMarketComponentHistory()) {
    items.push({
      child: (
        <div
          className={styles.itemContainer}
          onClick={() => {
            setIsBurgerMenuOpen(false);
            handleHistoryClick();
          }}
        >
          <div className={styles.iconContainer}>
            <FaInfo className={styles.icon} />
          </div>
          <div>
            <p className={styles.itemLabel}>{t('ui.history')}</p>
          </div>
        </div>
      ),
    });
  }

  // red rack
  items.push({
    child: (
      <div
        className={styles.itemContainer}
        onClick={() => {
          setIsBurgerMenuOpen(false);
          handleRedRackClick();
        }}
      >
        <div className={styles.iconContainer}>
          <FaCalendarCheck className={styles.icon} />
        </div>
        <div>
          <p className={styles.itemLabel}>{t('ui.redRackButton')}</p>
        </div>
      </div>
    ),
  });

  // markets
  items.push({
    child: (
      <div className={styles.itemContainer}>
        <div className={styles.iconContainer}>
          <FaBagShopping className={styles.icon} />
        </div>
        <div>
          <MarketSelectionView
            selectedValue={selectedValue}
            isMarketSelectionOpen={isMarketSelectionOpen}
            onChange={handleMarketSelectionChanged}
          />
        </div>
      </div>
    ),
  });

  return (
    <>
      {isChangeOwnPasswordDialogOpen && (
        <ChangeOwnPasswordView handleDialogCloseClick={handleChangeOwnPasswordDialogCloseClick} />
      )}

      {isHistoryDialogOpen && (
        <HistoryDialogView
          id={selectedValue}
          isMarketId
          showMarketComponentName
          name={t('ui.historyDialogMarketHeading')}
          handleDialogCloseClick={handleHistoryDialogCloseClick}
        />
      )}

      {isDetailsDialogOpen && (
        <MarketComponentDetailsDialogView
          marketComponent={marketComponentForValidation}
          handleDialogCloseClick={handleDetailsDialogCloseClick}
        />
      )}

      {loading && <LoaderView />}

      {!loading && (
        <div className={styles.menuContainer}>
          {/* User Information */}
          <div className={styles.userInformationContainer}>
            <FaRegUser className={styles.icon} />
            <p className={styles.userName}>
              {firstname}
              <br />
              {lastname}
            </p>
          </div>

          <div className={styles.burgerMenuContainer}>
            <FaBars
              className={styles.icon}
              onClick={() => setIsBurgerMenuOpen(!isBurgerMenuOpen)}
            />

            {isBurgerMenuOpen && <BurgerMenuView items={items} />}
          </div>
        </div>
      )}
    </>
  );
}
